import React, { useState } from "react";
import { Switch, Route } from "react-router-dom";
import "./landing.css";
import { neonColors } from "../../utils/generalUtils";
import Navbar from "./Navbar/Navbar.component";
import PublicationComponent from "./Publication/Publication.component";
import Teaching from "./Teaching/Teaching.component";
import Research from "./Research/Research.component";
import Students from "./Students/Students.component";
import Error404 from "./../Miscellaneous/Error404.component";
import Profile from "./Profile/Profile.component";
import Contact from "./Contact/Contact";
import EditorialAppointments from "./EditorialAppointments/EditorialAppointments.component";

const _random = (arr) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const Landing = () => {
  const [hoverColor] = useState(_random(neonColors));

  return (
    <div>
      <div>
        <Navbar color={hoverColor || "#fd5f00"} />
        <div className="h-100 p-0 rest-container">
          <Switch>
            <Route path="/publications">
              <PublicationComponent />
            </Route>
            <Route path="/teaching">
              <Teaching />
            </Route>
            <Route path="/research">
              <Research />
            </Route>
            <Route path="/editorialAppointments">
              <EditorialAppointments />
            </Route>
            <Route path="/students">
              <Students />
            </Route>
            <Route path="/home">
              <Profile bgColor={hoverColor} />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route exact path="/">
              <Profile bgColor={hoverColor} />
            </Route>
            <Route path="*">
              <Error404 />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Landing;
